module.exports = __webpack_public_path__ + "static/media/vip.dd62c84f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/悬浮窗/vip.png
// module id = 1098
// module chunks = 0